// eslint-disable-next-line import/prefer-default-export
export enum THEME_CODE {
  auroraBlue = 'aurora-blue',
  midnightBlack = 'midnight-black',
  cloudyGrey = 'cloudy-grey'
}
